import React from "react";
import PropTypes from "prop-types";
import { host, host_v2 } from "../../utilities/requests";
import { decrementPending, incrementPending } from "../../containers/actions";

export default class ConsolidatedShabihSazReports extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        examinations: [],
        first: { selected: null, openMenu: false },
        second: { selected: null, openMenu: false },
        analyses: [],
        isSubmitting: false,
    }

    requestInFlight = false;

    componentDidMount() {
        this.fetchExaminations();
        this.fetchAnalyses();
    }

    getToken() {
        return this.context.store.getState().get('application').get('token');
    }

    getAuthorizationHeader() {
        const token = this.getToken();
        return `${token.get('tokenType')} ${token.get('accessToken')}`;
    }

    async fetchExaminations() {
        this.context.store.dispatch(incrementPending());
        try {
            const now = new window.MomentJalali();
            if (now.jMonth() < 5) now.add(-1, 'jYear');
            now.jMonth(5);
            now.startOf('jMonth');
            let currentYear = (now.toDate().getTime() / 1000 + 12600);
            now.add(1, 'jYear');
            currentYear += ',' + (now.toDate().getTime() / 1000 + 12600);

            const response = await fetch(
                `${host}/api/examination/?examination_type=6&limit=10000&date__range=${currentYear}&react__route=${window.location.pathname}`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.getAuthorizationHeader(),
                    },
                },
            );
            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || "خطا در دریافت آزمون‌ها");
            this.setState({ examinations: data.results || [] });
        }
        catch (error) {
            console.log(error);
            alert("دریافت آزمون‌های شبیه‌ساز با خطا مواجه شد");
        }
        finally {
            this.context.store.dispatch(decrementPending());
        }
    }

    async fetchAnalyses() {
        try {
            const response = await fetch(
                `${host}/api/examination/shabih-saz-consolidated-analyses/`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.getAuthorizationHeader(),
                    },
                },
            );
            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || "خطا در دریافت تاریخچه تحلیل‌ها");
            this.setState({ analyses: data.results || [] });
        }
        catch (error) {
            console.log(error);
        }
    }

    selectExamination(target, examination) {
        const otherTarget = target === "first" ? "second" : "first";
        if (this.state[otherTarget].selected && this.state[otherTarget].selected.id === examination.id) {
            alert("دو آزمون انتخاب‌شده باید متفاوت باشند");
            return;
        }
        this.setState({
            [target]: { selected: examination, openMenu: false },
        });
    }

    toggleMenu(target) {
        const otherTarget = target === "first" ? "second" : "first";
        this.setState({
            [target]: { ...this.state[target], openMenu: !this.state[target].openMenu },
            [otherTarget]: { ...this.state[otherTarget], openMenu: false },
        });
    }

    clearSelection(target) {
        this.setState({ [target]: { selected: null, openMenu: false } });
    }

    getPayload(analyzeType) {
        const first = this.state.first.selected;
        const second = this.state.second.selected;
        if (!first || !second) {
            alert("لطفاً هر دو آزمون شبیه‌ساز را انتخاب کنید");
            return null;
        }
        if (first.id === second.id) {
            alert("دو آزمون انتخاب‌شده باید متفاوت باشند");
            return null;
        }
        return {
            FirstShabihSazId: Number(first.id),
            SecondShabihSazId: Number(second.id),
            ExamAnalyzeType: analyzeType,
        };
    }

    async postAnalysis(path, payload) {
        if (this.requestInFlight) return;
        this.requestInFlight = true;
        this.setState({ isSubmitting: true });
        this.context.store.dispatch(incrementPending());
        try {
            const response = await fetch(`${host_v2}/api/ShabihSazApi/${path}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.getAuthorizationHeader(),
                },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            if (!response.ok || result.errorId !== 0) {
                alert(result.errorTitle || "اجرای عملیات با خطا مواجه شد");
                return;
            }
            alert(result.result || "عملیات با موفقیت انجام شد");
            if (path === "StartCombineAnalyze") await this.fetchAnalyses();
        }
        catch (error) {
            console.log(error);
            alert("مشکلی در ارتباط با سرویس تحلیل پیش آمده است");
        }
        finally {
            this.requestInFlight = false;
            this.setState({ isSubmitting: false });
            this.context.store.dispatch(decrementPending());
        }
    }

    checkAnalysisReport() {
        const payload = this.getPayload(0);
        if (payload) this.postAnalysis("CheckExamsCanAnalyze", payload);
    }

    analysisReport(analyzeType) {
        const payload = this.getPayload(analyzeType);
        if (payload) this.postAnalysis("StartCombineAnalyze", payload);
    }

    renderSelector(label, target) {
        const state = this.state[target];
        return <div style={{ width: "100%", margin: "0px 0.5em 0px 0px" }}>
            <p style={{ marginBottom: "6px" }}>{window.gettext(label)}</p>
            <div className="consolidated-box-selectbtnbox">
                <div className="consolidated-box-selectbtn" onClick={() => this.toggleMenu(target)}>
                    <p className="consolidated-box-selectText">انتخاب آزمون</p>
                    <i className="fa-chevron-down fa-chevron-down-icon"></i>
                </div>
                <div className="consolidated-box-selectbtn">
                    {state.selected ? <div style={{ display: "flex", alignItems: "center" }}>
                        <i
                            onClick={() => this.clearSelection(target)}
                            className="fa fa-times"
                            style={{ marginLeft: ".5rem", color: "#333" }}></i>
                        <p className="consolidated-box-selectText">
                            {state.selected.id.persian()} - {state.selected.title} - {state.selected.grades[0] ? state.selected.grades[0].title : "بدون پایه"}
                        </p>
                    </div> : null}
                </div>
                <div className="consolidated-selectBox" style={{ display: state.openMenu ? "block" : "none" }}>
                    {this.state.examinations.map(item => <div
                        key={`${target}-${item.id}`}
                        className="consolidated-selectBox-item"
                        onClick={() => this.selectExamination(target, item)}>
                        <p className="consolidated-selectBox-item-text">
                            {item.id.persian()} - {item.title} - {item.grades[0] ? item.grades[0].title : "بدون پایه"}
                        </p>
                    </div>)}
                </div>
            </div>
        </div>;
    }

    btnstyle = {
        padding: "0.5em",
        fontFamily: "IRANSans, Arial, sans-serif",
        fontSize: "0.9em",
        borderWidth: "medium",
        borderStyle: "none",
        cursor: "pointer",
        outline: "none",
        minWidth: "6em",
        margin: "0px 0.5em 0px 0px",
        color: "white",
        borderRadius: "0.15em",
        boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
    }

    render() {
        const actionButtonStyle = {
            opacity: this.state.isSubmitting ? 0.6 : 1,
            cursor: this.state.isSubmitting ? "not-allowed" : "pointer",
        };
        return <div className="consolidated-box-container">
            <h3 style={{ textAlign: "center", marginBottom: "1.5rem" }}>تحلیل شبیه‌ساز تلفیقی</h3>
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                {this.renderSelector("انتخاب آزمون شبیه‌ساز اول", "first")}
                {this.renderSelector("انتخاب آزمون شبیه‌ساز دوم", "second")}
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                <button disabled={this.state.isSubmitting} style={{ ...this.btnstyle, ...actionButtonStyle, backgroundColor: "#dc3545", width: "250px" }} onClick={() => this.checkAnalysisReport()}>
                    {window.gettext("بررسی امکان تحلیل")}
                </button>
                <button disabled={this.state.isSubmitting} style={{ ...this.btnstyle, ...actionButtonStyle, backgroundColor: "rgb(50,50,255)", width: "250px" }} onClick={() => this.analysisReport(0)}>
                    {window.gettext("تحلیل کل جامعه")}
                </button>
                <button disabled={this.state.isSubmitting} style={{ ...this.btnstyle, ...actionButtonStyle, backgroundColor: "rgb(142, 68, 173)", width: "250px" }} onClick={() => this.analysisReport(1)}>
                    {window.gettext("تحلیل به تفکیک")}
                </button>
            </div>
            <div style={{ marginTop: "2rem", overflowX: "auto" }}>
                <h4 style={{ marginBottom: "1rem" }}>تاریخچه تحلیل‌های شبیه‌ساز تلفیقی</h4>
                <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center" }}>
                    <thead>
                        <tr>
                            {["آزمون اول", "آزمون دوم", "نوع تحلیل", "وضعیت", "اجراکننده", "شروع", "پایان"].map(title =>
                                <th key={title} style={{ border: "1px solid #ddd", padding: "8px" }}>{title}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.analyses.length ? this.state.analyses.map(analysis =>
                            <tr key={analysis.id}>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{analysis.first_examination_title}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{analysis.second_examination_title}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{analysis.analyze_type_display}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }} title={analysis.error_message || ""}>{analysis.status_display}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{analysis.requested_by || "-"}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{analysis.started_at ? new Date(analysis.started_at).toLocaleString('fa-IR') : "-"}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{analysis.finished_at ? new Date(analysis.finished_at).toLocaleString('fa-IR') : "-"}</td>
                            </tr>
                        ) : <tr><td colSpan="7" style={{ padding: "12px" }}>هنوز تحلیلی ثبت نشده است.</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>;
    }
}
